import { Service, Clinic, Testimonial, Award, Stat } from "../types";

export const NAV_LINKS = [
  "About",
  "Services",
  "Clinics",
  "Testimonials",
  "Awards",
  "Contact",
];

export const SERVICES: Service[] = [
  {
    icon: "🫘",
    title: "Chronic Kidney Disease",
    desc: "Comprehensive management of CKD from early stages to advanced renal failure with personalised treatment plans.",
  },
  {
    icon: "🔬",
    title: "Kidney Transplant",
    desc: "Pre-transplant evaluation, post-transplant care and immunosuppression management for optimal graft survival.",
  },
  {
    icon: "💉",
    title: "Dialysis Management",
    desc: "Haemodialysis and peritoneal dialysis initiation, prescription, adequacy and complication management.",
  },
  {
    icon: "🩺",
    title: "Renal Biopsy",
    desc: "Ultrasound-guided percutaneous renal biopsy for accurate diagnosis of glomerular and tubulointerstitial diseases.",
  },
  {
    icon: "🫀",
    title: "Hypertension & CKD",
    desc: "Expert management of resistant hypertension and hypertensive nephropathy to slow disease progression.",
  },
  {
    icon: "🍬",
    title: "Diabetic Nephropathy",
    desc: "Specialised care for kidney complications from diabetes, including proteinuria and renal function preservation.",
  },
  {
    icon: "⚡",
    title: "Acute Kidney Injury",
    desc: "Rapid assessment and intensive management of AKI in ICU and ward settings with multidisciplinary support.",
  },
  {
    icon: "🧬",
    title: "Glomerulonephritis",
    desc: "Diagnosis and treatment of immune-mediated kidney diseases including IgA nephropathy and nephrotic syndrome.",
  },
];

export const CLINICS: Clinic[] = [
  {
    name: "Ashtamangal Surgical Hospital",
    address:
      "2nd Floor, Ashtamangal Complex, Opp. Kedar Tower, Shahibaug, Ahmedabad – 380004",
    phone: "+91 91572 60376",
    timings: [
      { day: "Monday – Saturday", time: "10:00 AM – 11:30 AM" },
      { day: "Sunday", time: "By Appointment" },
    ],
    color: "from-blue-600 to-blue-800",
    mapLink: "https://share.google/2SyHTyIxeres9wCTn",
    coordinates: { lat: 23.1815, lng: 72.5429 },
  },
  {
    name: "Invictus Gastro Hospital",
    address:
      "3rd Floor, A Block, Roseville Sky, Shukan Cross Road, Opp. Pushkar Icon, New Naroda, Nikol, Ahmedabad – 382345",
    phone: "+91 91572 60376",
    timings: [
      { day: "Monday – Saturday", time: "4:00 PM – 7:30 PM" },
      { day: "Sunday", time: "By Appointment" },
    ],
    color: "from-teal-600 to-teal-800",
    mapLink: "https://share.google/lId5y1kwleYN2Y2et",
    coordinates: { lat: 23.224, lng: 72.603 },
  },
];

export const TESTIMONIALS: Testimonial[] = [
  {
    name: "Ramesh Patel",
    role: "Patient, CKD Stage 3",
    text: "Dr. Gaurav Modi explained my kidney condition in simple language and created a personalised plan that truly helped. My creatinine levels have stabilized. Forever grateful.",
    stars: 5,
  },
  {
    name: "Sunita Shah",
    role: "Transplant Patient",
    text: "After my kidney transplant, Dr. Modi's post-transplant care has been exceptional. He is always available and monitors every detail. Best nephrologist in Ahmedabad.",
    stars: 5,
  },
  {
    name: "Dr. Priya Mehta",
    role: "Referring Physician, MD",
    text: "I regularly refer my nephrology patients to Dr. Gaurav Modi. His clinical acumen, attention to detail and compassionate approach make him stand out in the field.",
    stars: 5,
  },
  {
    name: "Haresh Desai",
    role: "Dialysis Patient",
    text: "I have been under Dr. Modi's dialysis care for 2 years. His team is professional and he reviews my cases personally. I feel safe and well cared for.",
    stars: 5,
  },
  {
    name: "Kavita Joshi",
    role: "Diabetic Nephropathy Patient",
    text: "Dr. Modi caught my kidney complication early. His prompt action and treatment plan have helped me maintain good kidney function despite diabetes.",
    stars: 5,
  },
];

export const AWARDS: Award[] = [
  {
    year: "2023",
    title: "Best Nephrologist – Ahmedabad",
    org: "Healthcare Excellence Awards",
  },
  {
    year: "2022",
    title: "Outstanding Research in Nephrology",
    org: "Indian Society of Nephrology",
  },
  {
    year: "2021",
    title: "Best Oral Presentation",
    org: "ISN World Congress of Nephrology",
  },
  {
    year: "2020",
    title: "Young Achiever in Medicine",
    org: "Gujarat Medical Association",
  },
];

export const STATS: Stat[] = [
  { value: "10+", label: "Years Experience" },
  { value: "5000+", label: "Patients Treated" },
  { value: "500+", label: "Transplants Assisted" },
  { value: "4.9★", label: "Patient Rating" },
];
